// eslint-disable-next-line boundaries/element-types
import { EditorModes, ReviewType, } from "@buildwithflux/models";
import { filterTruthy } from "../../helpers";
import { calculateAirwires } from "../../pcb";
import { getProblemTypeKeyFromReviewType } from "../types";
function pairValues(array) {
    const result = [];
    for (let i = 0; i < array.length; i += 2) {
        result.push([array[i], array[i + 1]]);
    }
    return result;
}
export class AirwiresValidator {
    runCalculateAirwiresInWorker;
    reviewType = ReviewType.DesignRuleCheckAirwire;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    constructor(runCalculateAirwiresInWorker = null) {
        this.runCalculateAirwiresInWorker = runCalculateAirwiresInWorker;
    }
    async checkForProblems(inputs) {
        if (!inputs.pcbConnectivityGraphPromise)
            throw new Error("Missing pcbConnectivityGraphPromise in inputs");
        const pcbConnectivityGraph = await inputs.pcbConnectivityGraphPromise;
        const netToConnectedComponents = pcbConnectivityGraph.getNetToConnectedComponents();
        if (!netToConnectedComponents) {
            // TODO: We should probably return a loading state here
            return { error: false, problemTypeKey: this.problemTypeKey, foundProblems: [] };
        }
        // Our netMap gives us the info of the groups that should be connected together,
        // we use this info to overlap it with the connected components from the graph.
        const netWithProblems = Object.entries(netToConnectedComponents)
            // If we found a net that is part of multiple connected components, then it's disconnected!
            .filter((a) => a[1].length > 1);
        const connectedComponents = pcbConnectivityGraph.getConnectedComponents();
        if (!connectedComponents?.length) {
            return { error: false, problemTypeKey: this.problemTypeKey, foundProblems: [] };
        }
        // calculate connected airwires for the whole PCB layout
        // Fix this - calculateAirwires(..) is overly generalized. For example, it's internally doing
        // geometry calculations (distance, etc.) that are not needed for this validator, and yet that
        // extra work is being done anyway. TODO: refactor calculateAirwires into smaller units of code
        // that focus on specific tasks (like airwire id's) rather than doing everything we 'might need'
        // in a single function.
        let airwiresNodeIds = [];
        if (this.runCalculateAirwiresInWorker) {
            airwiresNodeIds = (await this.runCalculateAirwiresInWorker(inputs.pcbNetMap ?? inputs.netMap, connectedComponents, inputs.pcbLayoutNodes, Object.fromEntries(inputs.pcbPrimitiveStore
                .getAllNodeUidsWithShapes()
                .map((uid) => [uid, inputs.pcbPrimitiveStore.getNodePositionWorld(uid)])), pcbConnectivityGraph.getAllNodeAttributes())).airwiresNodeIds;
        }
        else {
            airwiresNodeIds = calculateAirwires(inputs.pcbNetMap ?? inputs.netMap, connectedComponents, inputs.pcbLayoutNodes, {
                getNodeAttributes: pcbConnectivityGraph.getNodeAttributes.bind(pcbConnectivityGraph),
                getNodePositionWorld: inputs.pcbPrimitiveStore.getNodePositionWorld.bind(inputs.pcbPrimitiveStore),
            }).airwiresNodeIds;
        }
        // identify connected pin pairs
        const connectedPinPairs = pairValues(airwiresNodeIds);
        const netWithConnectedPins = netWithProblems.map((np) => {
            const items = np[1].flat();
            return {
                net: np[0],
                pinPairs: connectedPinPairs.filter((i) => (i[0] && items.includes(i?.[0])) || (i[1] && items.includes(i[1]))),
            };
        });
        // create error object with the found problems
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems: netWithConnectedPins.reduce((problems, netWithConnectedPin) => {
                const { net, pinPairs } = netWithConnectedPin;
                // eslint-disable-next-line @buildwithflux/no-array-foreach
                pinPairs.forEach((pins) => {
                    problems.push({
                        problemTypeKey: this.problemTypeKey,
                        key: `${this.problemTypeKey}_${net}_${pins.join("+")}`,
                        affectedItems: filterTruthy(pins.map((pin) => (pin ? { type: "pcbLayoutNode", uid: pin } : null))),
                        affectedViews: [EditorModes.pcb],
                    });
                });
                return problems;
            }, []),
        };
    }
}
//# sourceMappingURL=AirwiresValidator.js.map